"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DMSConstants {
}
exports.default = DMSConstants;
DMSConstants.DMS_PING_INTERVAL = 10000;
DMSConstants.PING_PAYLOAD = Buffer.from([2, 3, 1, 0, 1, 9, 8, 9]);
//# sourceMappingURL=DMSConstants.js.map